import PropTypes from 'prop-types';

import { useContext } from 'react';

import MaterialsCaptureContext from '../../context/MaterialsCaptureContext';

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

const DialysisForm = ({ data }) => {
  const { handleInputChange, formErrors } = useContext(MaterialsCaptureContext);

  return(
    <Grid container spacing={1} mt={1}>
      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Dialysis consumable manufactuer"
          name={`dialysis_consumable_manufactuer-${data?.index}`}
          value={data?.dialysis_consumable_manufactuer}
          onChange={e => 
            handleInputChange(
              e, data?.index, 'dialysis_consumable_manufactuer', e.target.value
            )
          }
          helperText={formErrors[`dialysis_consumable_manufactuer-${data?.index}`]}
          error={`dialysis_consumable_manufactuer-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Dialysis consumable product code"
          name={`dialysis_consumable_product_code-${data?.index}`}
          value={data?.dialysis_consumable_product_code}
          onChange={e => 
            handleInputChange(
              e, data?.index, 'dialysis_consumable_product_code', e.target.value
            )
          }
          helperText={formErrors[`dialysis_consumable_product_code-${data?.index}`]}
          error={`dialysis_consumable_product_code-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Dialysis consumbale volume (mL)"
          name={`dialysis_consumbale_volume-${data?.index}`}
          value={data?.dialysis_consumbale_volume}
          onChange={e => 
            handleInputChange(
              e, data?.index, 'dialysis_consumbale_volume', e.target.value
            )
          }
          helperText={formErrors[`dialysis_consumbale_volume-${data?.index}`]}
          error={`dialysis_consumbale_volume-${data?.index}` in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Dialysis buffer volume (mL)"
          name={`dialysis_buffer_volume-${data?.index}`}
          value={data?.dialysis_buffer_volume}
          onChange={e => 
            handleInputChange(
              e, data?.index, 'dialysis_buffer_volume', e.target.value
            )
          }
          helperText={formErrors[`dialysis_buffer_volume-${data?.index}`]}
          error={`dialysis_buffer_volume-${data?.index}` in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="No of buffer exchanges"
          name={`no_of_buffer_exchanges-${data?.index}`}
          value={data?.no_of_buffer_exchanges}
          onChange={e => 
            handleInputChange(e, data?.index, 'no_of_buffer_exchanges', e.target.value)
          }
          helperText={formErrors[`no_of_buffer_exchanges-${data?.index}`]}
          error={`no_of_buffer_exchanges-${data?.index}` in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Time for buffer exchange 1 (hours)"
          name={`time_for_buffer_exchange_1-${data?.index}`}
          value={data?.time_for_buffer_exchange_1}
          onChange={e => 
            handleInputChange(
              e, data?.index, 'time_for_buffer_exchange_1', e.target.value
            )
          }
          helperText={formErrors[`time_for_buffer_exchange_1-${data?.index}`]}
          error={`time_for_buffer_exchange_1-${data?.index}` in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Time for buffer exchange 2 (hours)"
          name={`time_for_buffer_exchange_2-${data?.index}`}
          value={data?.time_for_buffer_exchange_2}
          onChange={e => 
            handleInputChange(
              e, data?.index, 'time_for_buffer_exchange_2', e.target.value
            )
          }
          helperText={formErrors[`time_for_buffer_exchange_2-${data?.index}`]}
          error={`time_for_buffer_exchange_2-${data?.index}` in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Time for buffer exchange 3 (hours)"
          name={`time_for_buffer_exchange_3-${data?.index}`}
          value={data?.time_for_buffer_exchange_3}
          onChange={e => 
            handleInputChange(
              e, data?.index, 'time_for_buffer_exchange_3', e.target.value
            )
          }
          helperText={formErrors[`time_for_buffer_exchange_3-${data?.index}`]}
          error={`time_for_buffer_exchange_3-${data?.index}` in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Tempertaure °C"
          name={`tempertaure-${data?.index}`}
          value={data?.tempertaure}
          onChange={e => 
            handleInputChange(e, data?.index, 'tempertaure', e.target.value)
          }
          helperText={formErrors[`tempertaure-${data?.index}`]}
          error={`tempertaure-${data?.index}` in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Final concention (mg/ml)"
          name={`final_concention-${data?.index}`}
          value={data?.final_concention}
          onChange={e => 
            handleInputChange(e, data?.index, 'final_concention', e.target.value)
          }
          helperText={formErrors[`final_concention-${data?.index}`]}
          error={`final_concention-${data?.index}` in formErrors}
          type='number'
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

DialysisForm.propTypes = {
  data: PropTypes.object.isRequired,
};

export default DialysisForm;